import React, { useState, useRef, useEffect, } from "react";
import CalendarIcon from "../../../assets/icons/calendar/calendar.svg";
import { isValidDate } from "../../../common/helper";
import "react-day-picker/lib/style.css";
import "./styles.css";

import DatePicker from "react-datepicker";
import { registerLocale, } from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import enUS from 'date-fns/locale/en-US';
import moment from 'moment';


export const CustomDatePicker = ({ onChange, label, required, locale = enUS, value,
  minDate, maxDate,
  validation, disabled, className, isInvalid = false }) => {
  const FORMAT = 'yyyy-MM-dd';
  isInvalid = disabled ? false : isInvalid;
  validation = disabled ? false : validation;
  const [startDate, setStartDate] = useState(value ? new Date(value) : null);
  let calendar = useRef();

  useEffect(() => {
    if (!value || value.trim() === "") {
      setStartDate('')
    }
  }, [value])

  const openDatepicker = () => calendar && calendar.setOpen(true);
  registerLocale(locale.code, locale);

  const getValidDate = (inputDate) => {
    if (inputDate) {
      let dateParts = inputDate.split("-");
      if (dateParts && dateParts.length >= 2) {
        let date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
        return date;
      }
    }
  }

  return <div className={`custom-date-picker ${className} ${isInvalid || (validation && ((required && !value) || !isValidDate(value))) ? 'date-picker-empty' : ''} ${disabled ? 'disabled' : ''}`} >
    <label>
      {label}{required && <b>*</b>}
    </label>
    <DatePicker selected={startDate} onChange={(date) => { let e = { target: { value: moment(date).format('yyyy-MM-DD') } }; onChange(e); setStartDate(date) }}
      showMonthDropdown
      showYearDropdown
      yearDropdownItemNumber={10}
      locale={locale}
      peekNextMonth
      placeholderText={FORMAT.toUpperCase()}
      disabled={disabled}
      ref={(c) => { calendar = c }}
      dateFormat="yyyy-MM-dd"
      minDate={minDate && getValidDate(minDate)}
      maxDate={maxDate && getValidDate(maxDate)}
    />
    <img className="calendar-icon" src={CalendarIcon} alt='' onClick={openDatepicker} style={{ cursor: "pointer" }} />
  </div>

};
